import { getUserNeedsCityFromToken, getUserNeedsPhoneFromToken } from 'api';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GoogleSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const needsPhone = getUserNeedsPhoneFromToken(token);
    const needsCity = getUserNeedsCityFromToken(token);
    const redirectPath = localStorage.getItem('redirectPath');
    const redirectPathObj = redirectPath ? JSON.parse(redirectPath) : null;

    if (token) {
      localStorage.setItem('token', token);

      if (needsPhone && needsCity) {
        navigate('/redaguoti-profili', {
          state: {
            needsPhone: true,
            needsCity: true,
          },
        });
      } else {
        // Redirect to the saved path or default to '/info'
        const to = redirectPathObj?.pathname || '/info';
        localStorage.removeItem('redirectPath');
        navigate(to);
      }
    } else {
      navigate('/prisijungimas');
    }
  }, [location, navigate]);

  return null; // Or show a spinner
};

export default GoogleSuccess;
